import React from "react";
import styles from "./PeopleUI.module.css";
import RowActionsMenu from "../../../components/common/RowActionsMenu";
import ResourceTypeIcon from "./ResourceTypeIcon";

const TYPE_ICON_CLASS = {
  vehicle: styles.resourceIconVehicle,
  tool: styles.resourceIconTool,
  misc: styles.resourceIconMisc,
};

const STATUS_CLASS = {
  available: styles.statusAvailable,
  in_use: styles.statusInUse,
  maintenance: styles.statusMaintenance,
  unavailable: styles.statusUnavailable,
};

const STATUS_LABEL = {
  available: "Available",
  in_use: "In use",
  maintenance: "Maintenance",
  unavailable: "Unavailable",
};

const TYPE_LABEL = {
  misc: "Miscellaneous",
  vehicle: "Vehicle",
  tool: "Tool / Equipment",
};

export default function ResourceRow({ resource, onClick, actions }) {
  const iconClass = TYPE_ICON_CLASS[resource.type] || styles.resourceIconMisc;
  const statusClass = STATUS_CLASS[resource.availability_status] || styles.statusUnavailable;
  const statusLabel = STATUS_LABEL[resource.availability_status] || resource.availability_status;
  const typeLabel = TYPE_LABEL[resource.type] || resource.type;
  const extra = resource.type === "vehicle"
    ? (resource.registration_number || "")
    : (resource.cost_center || "");

  return (
    <div
      className={`${styles.listRow} ${styles.resourceListRow}`}
      onClick={onClick}
      role="row"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <span
        className={`${styles.resourceIcon} ${iconClass}`}
        aria-hidden="true"
        style={{ width: 28, height: 28, fontSize: "0.95rem" }}
      >
        <ResourceTypeIcon type={resource.type} />
      </span>
      <span className={styles.listCellName}>
        {resource.name}
        {!resource.is_active && (
          <span className={styles.archivedBadge} style={{ position: "static", marginLeft: 8 }}>
            Archived
          </span>
        )}
      </span>
      <span className={`${styles.listCellMeta} ${styles.resourceListColType}`}>{typeLabel}</span>
      <span>
        <span className={`${styles.statusPill} ${statusClass}`}>
          <span className={styles.statusDot} aria-hidden="true" />
          {statusLabel}
        </span>
      </span>
      <span className={`${styles.listCellMeta} ${styles.resourceListColExtra}`}>{extra}</span>
      <span className={styles.listCellActions}>
        {actions && actions.length > 0 && <RowActionsMenu actions={actions} />}
      </span>
    </div>
  );
}

export function ResourceListHeader() {
  return (
    <div className={`${styles.listHeaderRow} ${styles.resourceListHeaderRow}`} role="row">
      <span aria-hidden="true" />
      <span>Name</span>
      <span className={styles.resourceListColType}>Type</span>
      <span>Status</span>
      <span className={styles.resourceListColExtra}>Reference</span>
      <span aria-hidden="true" />
    </div>
  );
}
